import { getDescrizioneMarcaFromArticolo } from '../../../helpers';
import { getLocaleFromLanguageCode } from '../../../intl-helpers';
import get from 'lodash/get';
import transform from 'lodash/transform';
import omit from 'lodash/omit';

// I metodi in questa utils andranno a sostituire tutti quelli dichiarati all' interno dei vari component

// Get marca di un articolo
export const getMarcaArticolo = (productDetails) => {
    return getDescrizioneMarcaFromArticolo(productDetails, getLocale());
}

// Get codice di un articolo
export const getCodiceArticolo = (productDetails) => {
    return get(productDetails, 'identificazione.codice_articolo.value');

}

// Get descrizione di un articolo
export const getDescrizioneArticolo = (productDetails) => {
    return get(
        productDetails,
        `identificazione.descrizione_articolo.value.${getLocale()}`
    )
}

// Get della locale da una stringa, di solito viene passato una stringa tipo 'it'
export const getLocale = (language = null) => {
    return getLocaleFromLanguageCode(language)
}

// Funzione che normalizza i dettagli delle etim_class
export const normalizeEtimClassDetails = (etimClass) => {
    return {
        ...etimClass,
        etim_features: transform(
            etimClass.etim_features,
            (collection, feature) => {
                collection[feature.id] = {
                    ...omit(feature, 'description'),
                    label: feature.description,
                };

                return collection;
            },
            {}
        ),
    }
}